import { Component, OnInit, Input } from '@angular/core';
import { ListPriceMove } from '../../../classes/enums';

@Component({
  selector: 'app-listing-price-arrow',
  templateUrl: './listing-price-arrow.component.html',
  styleUrls: ['./listing-price-arrow.component.scss']
})
export class ListingPriceArrowComponent implements OnInit {

  ListPriceMoveType: typeof ListPriceMove = ListPriceMove;

  @Input() listPriceMove: ListPriceMove;

  @Input() width: number;
  @Input() color: 'white'|undefined;

  constructor() { }

  ngOnInit() {
  }

}
